import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=7bf8b474&scoped=true&"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8b474",
  null
  
)

export default component.exports